import React from "react";
import { X, Trash2 } from "lucide-react";
import { Link } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { inr } from "@/lib/api";
import { imgUrl } from "@/components/ImageUploader";

export default function CartDrawer() {
  const { items, remove, setQty, subtotal, open, setOpen } = useCart();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex" data-testid="cart-drawer">
      <div className="flex-1 bg-black/40" onClick={() => setOpen(false)} />
      <div className="w-full sm:max-w-md bg-[#FCE4EC] h-full flex flex-col shadow-2xl pb-safe">
        <div className="flex justify-between items-center p-5 border-b" style={{ borderColor: "rgba(212,175,55,0.25)" }}>
          <div className="font-serif text-xl text-[#0B1F3A]">Your Cart</div>
          <button onClick={() => setOpen(false)} data-testid="close-cart"><X size={22} /></button>
        </div>
        <div className="flex-1 overflow-auto p-5 space-y-4">
          {items.length === 0 && <div className="text-center text-[#1E293B]/60 py-16">
            <div className="font-serif text-2xl text-[#0B1F3A] mb-2">Your cart is empty</div>
            <div className="text-sm mb-6">Discover festive edits & everyday essentials.</div>
            <button onClick={() => setOpen(false)} className="bg-[#0B1F3A] text-[#FFF9E6] px-6 py-3 text-sm tracking-wider uppercase">Continue Shopping</button>
          </div>}
          {items.map((i, idx) => (
            <div key={idx} className="flex gap-3 bg-white p-3 border" style={{ borderColor: "rgba(212,175,55,0.25)" }} data-testid={`cart-item-${idx}`}>
              <img src={imgUrl(i.image)} className="w-20 h-28 object-cover" alt="" />
              <div className="flex-1">
                <div className="font-serif text-sm text-[#0B1F3A] leading-snug">{i.name}</div>
                <div className="text-xs text-[#1E293B]/60 mt-1">{i.size} · {i.color}</div>
                <div className="flex items-center gap-2 mt-2">
                  <button onClick={() => setQty(idx, i.quantity - 1)} className="w-7 h-7 border" style={{ borderColor: "rgba(212,175,55,0.35)" }} data-testid={`dec-${idx}`}>−</button>
                  <span className="text-sm w-6 text-center">{i.quantity}</span>
                  <button onClick={() => setQty(idx, i.quantity + 1)} className="w-7 h-7 border" style={{ borderColor: "rgba(212,175,55,0.35)" }} data-testid={`inc-${idx}`}>+</button>
                  <div className="ml-auto text-sm font-semibold text-[#D4AF37]">{inr(i.price * i.quantity)}</div>
                </div>
              </div>
              <button onClick={() => remove(idx)} className="text-[#1E293B]/40 hover:text-red-600" data-testid={`remove-${idx}`}><Trash2 size={16} /></button>
            </div>
          ))}
        </div>
        {items.length > 0 && (
          <div className="border-t p-5 space-y-3" style={{ borderColor: "rgba(212,175,55,0.25)" }}>
            <div className="flex justify-between text-sm"><span>Subtotal</span><span className="font-semibold" data-testid="cart-subtotal">{inr(subtotal)}</span></div>
            <Link to="/checkout" onClick={() => setOpen(false)} className="block text-center bg-[#0B1F3A] text-[#FFF9E6] py-3 text-sm tracking-widest uppercase hover:bg-[#163056]" data-testid="checkout-btn">Checkout</Link>
          </div>
        )}
      </div>
    </div>
  );
}
